// Quando mostrar a faixa de piracema na "Evolução da produção".
//
// O defeso de 01/nov a fim de fev (PIRACEMA em EvolucaoProducao.tsx) é o da bacia do Paraná. Só faz sentido sombrear o gráfico
// quando TODA a produção mostrada é dessa bacia; com locais de outra bacia (ex.: sistemas estuarinos), a faixa enganaria.

export const BACIA_DA_PIRACEMA = 'Bacia do Alto Paraná';

export interface NoArvoreMin {
  uid_pesca_local: string;
  uid_pesca_local_pai?: string | null;
  nome: string;
}

export interface ItemNivelMin {
  nome: string;
  /** 'no' = local da árvore; 'proprio' ("Direto em X") e 'sem_vinculo' não têm bacia própria. */
  categoria: string;
}

const normalizar = (t: string) => t.normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase();

const ehBaciaDaPiracema = (nome: string) => normalizar(nome) === normalizar(BACIA_DA_PIRACEMA);

/** Sobe pelos pais até a raiz (com proteção contra ciclo). null se o nó não existe na árvore. */
export function raizDoNo(uid: string, arvore: NoArvoreMin[]): NoArvoreMin | null {
  const porUid = new Map(arvore.map((n) => [n.uid_pesca_local, n]));
  let atual = porUid.get(uid) ?? null;
  const vistos = new Set<string>();
  while (atual && atual.uid_pesca_local_pai && porUid.has(atual.uid_pesca_local_pai) && !vistos.has(atual.uid_pesca_local)) {
    vistos.add(atual.uid_pesca_local);
    atual = porUid.get(atual.uid_pesca_local_pai) ?? null;
  }
  return atual;
}

/**
 * - Com filtro de local: todos os locais selecionados têm como raiz a bacia da piracema.
 * - Sem filtro de local: todos os itens do nível raiz do gráfico "Produção por local" (que já respeita projeto e demais filtros),
 *   ignorando "Sem local vinculado", são essa bacia — e há pelo menos um. Sem esse nível ainda carregado: esconde.
 */
export function devePiracema(params: { locaisSelecionados: string[]; arvore: NoArvoreMin[]; itensNivelRaiz: ItemNivelMin[] | null }): boolean {
  const { locaisSelecionados, arvore, itensNivelRaiz } = params;
  if (locaisSelecionados.length > 0) {
    return locaisSelecionados.every((uid) => {
      const raiz = raizDoNo(uid, arvore);
      return !!raiz && ehBaciaDaPiracema(raiz.nome);
    });
  }
  if (!itensNivelRaiz) return false;
  const locais = itensNivelRaiz.filter((i) => i.categoria === 'no');
  return locais.length > 0 && locais.every((i) => ehBaciaDaPiracema(i.nome));
}
